export const links = {
  loginHelp: 'https://edu.rosminzdrav.ru/voprosy-otvety/help/?no_cache=1',
  fillRequestUrl: 'https://edu.rosminzdrav.ru/organizacijam/podacha-zajavok/',
  loadUserTerms: 'https://edu.rosminzdrav.ru/index.php?id=82'
};

export const hideElementsForDemo = true;

export const authHeaderName = 'Authorization';
